import { Link, Paragraph } from '@vimeo/iris/typography';

export default function Groups() {
  return (
    <div>
      <Paragraph size="2">
        A <em>group</em> is a community within Vimeo for collaborating, sharing, and engaging with
        videos. Groups can be public, where anyone can join, or they can be private, where
        membership is by invitation only. For more information, see our{' '}
        <Link
          variant="minimal"
          href="https://vimeo.com/help/sso?redirect_to=https://help.vimeo.com/hc/en-us/articles/12426231717905"
        >
          Help Center
        </Link>
        .
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
